/* POC landing blocks: swipe carousels (dots, wrap-around arrows, keys) + floating CTA on phones. */
(function () {
  if (window.__pocLp) return;
  window.__pocLp = true;

  function initCar(car) {
    if (car.__done) return;
    car.__done = true;
    var track = car.querySelector(".poc-lp-car__track");
    var slides = Array.prototype.slice.call(track.children);
    var dots = Array.prototype.slice.call(
      car.querySelectorAll(".poc-lp-car__dot"),
    );
    if (slides.length < 2) return;

    function current() {
      var x = track.scrollLeft,
        best = 0,
        d = Infinity;
      slides.forEach(function (s, i) {
        var dd = Math.abs(s.offsetLeft - track.offsetLeft - x);
        if (dd < d) {
          d = dd;
          best = i;
        }
      });
      // at the end of the track the last visible card counts as current
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4)
        best = slides.length - 1;
      return best;
    }
    function go(i) {
      var n = slides.length;
      i = ((i % n) + n) % n;
      track.scrollTo({
        left: slides[i].offsetLeft - track.offsetLeft,
        behavior: "smooth",
      });
    }
    function paint() {
      var c = current();
      dots.forEach(function (d, i) {
        d.classList.toggle("is-on", i === c);
        d.setAttribute("aria-current", i === c ? "true" : "false");
      });
    }
    var t;
    track.addEventListener(
      "scroll",
      function () {
        clearTimeout(t);
        t = setTimeout(paint, 60);
      },
      { passive: true },
    );
    dots.forEach(function (d, i) {
      d.addEventListener("click", function () {
        go(i);
      });
    });
    var prev = car.querySelector(".poc-lp-car__arrow--prev"),
      next = car.querySelector(".poc-lp-car__arrow--next");
    if (prev)
      prev.addEventListener("click", function () {
        go(current() - 1);
      });
    if (next)
      next.addEventListener("click", function () {
        var atEnd =
          track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        go(atEnd ? 0 : current() + 1);
      });
    track.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") {
        e.preventDefault();
        go(current() + 1);
      }
      if (e.key === "ArrowLeft") {
        e.preventDefault();
        go(current() - 1);
      }
    });
  }

  function initFloat() {
    var src = document.querySelector(".poc-lp__float-src");
    if (!src || document.querySelector(".poc-lp-float")) return;
    var first = document.querySelector(".poc-lp .poc-cta");
    if (!first) return;
    var wrap = document.createElement("div");
    wrap.className = "poc-lp-float";
    var a = document.createElement("a");
    a.className = "poc-cta";
    a.href = first.href;
    a.innerHTML =
      '<span class="poc-cta__text"><span class="poc-cta__label"></span></span><span class="poc-cta__arrow" aria-hidden="true">&rarr;</span>';
    a.querySelector(".poc-cta__label").textContent =
      src.getAttribute("data-label") || "Personalize Yours";
    wrap.appendChild(a);
    document.body.appendChild(wrap);
    // keep the market param the page's own button got
    setTimeout(function () {
      a.href = first.href;
    }, 300);

    var ctas = Array.prototype.slice.call(
      document.querySelectorAll(".poc-lp .poc-cta"),
    );
    var footer = document.querySelector(
      'footer, .footer, #shopify-section-footer, [id*="__footer"]',
    );
    var seen = new Set(),
      passedFirst = false;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) seen.add(e.target);
        else seen.delete(e.target);
        if (
          e.target === first &&
          !e.isIntersecting &&
          e.boundingClientRect.top < 0
        )
          passedFirst = true;
        if (e.target === first && e.isIntersecting) passedFirst = false;
      });
      wrap.classList.toggle("is-on", seen.size === 0);
    });
    ctas.forEach(function (c) {
      io.observe(c);
    });
    if (footer) io.observe(footer);
  }

  function boot() {
    document.querySelectorAll("[data-poc-car]").forEach(initCar);
    initFloat();
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", function () {
    document.querySelectorAll("[data-poc-car]").forEach(initCar);
  });
})();
